import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProAfterMeetingContent のスタイル
 */
export const hotlineProAfterMeetingContentStyle = tv({
    slots: {
        base: [],
        completedSection: [
            'flex flex-col items-center gap-16',
            'w-full',
            'pb-24',
            'mb-24',
            'border-solid border-b border-t-0 border-x-0 border-gray-300',
        ],
        description: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex flex-col gap-8',
            'w-full',
            'p-16',
            'rounded-md',
            'bg-orange-50',
        ],
        descriptionTitle: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        historySection: ['flex flex-col gap-24'],
        sectionTitle: [headStyle({ color: 'base', isBold: true, size: 'xs' })],
        text: [textStyle({ color: 'base', size: 'sm' })],
    },
});
